import { render, staticRenderFns } from "./ResetInfoModal.vue?vue&type=template&id=76d66805&scoped=true&"
import script from "./ResetInfoModal.vue?vue&type=script&lang=js&"
export * from "./ResetInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetInfoModal.vue?vue&type=style&index=0&id=76d66805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d66805",
  null
  
)

export default component.exports